<app-brand-header [maxBrandColumns]="MAX_BRAND_COLUMNS"></app-brand-header>
<div class="marketing-report-content">
  @if (messagingData?.categories) {
  @for (category of messagingData!.categories; track category.name; let last = $last) {
  @if (last) {
  <app-messaging-category-table [data]="category" [maxBrandColumns]="MAX_BRAND_COLUMNS" appInfiniteScroll
    (scrolled)="onLoadMore()">
  </app-messaging-category-table>
  } @else {
  <app-messaging-category-table [data]="category" [maxBrandColumns]="MAX_BRAND_COLUMNS">
  </app-messaging-category-table>
  }
  }
  }
</div>
@if (isLoading) {
<div class="loading-spinner">
  <app-spinner-icon></app-spinner-icon>
</div>
}

@if (!messagingData?.categories?.length && !isLoading) {
<div class="no-data-container">
  <img [src]="'svg/no-data-no-text.svg' | assetVersion" alt="No data" class="no-data-image">
  <div class="no-data-text">
    <span class="main-text">No Messaging Insights Available</span>
    <span class="sub-text">Try adjusting brands or filters </span>
    <span class="sub-text">to explore available messaging.</span>
  </div>
</div>
}